// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publications-container {
  padding: 0;
}

.publications-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.publications-header h1 {
  /* font-size: 2rem; */
  font-weight: 700;
  color: #374151;
}

/* Aligner les marges du TabNav sur la page Commandes */
.publications-container .tab-nav {
  margin-bottom: 3rem;
}

/* Aligner la marge du button-group sur la page Commandes */
.publications-container .button-group {
  margin-top: 0;
  margin-bottom: 3rem;
}

/* Loading */
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 300px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.loading-indicator .spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: publications-spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes publications-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Spinner inline du bouton "Candidature fictive" pendant la (re)recuperation de l'AC demo. */
.demo-btn-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(55, 65, 81, 0.3);
  border-top-color: #f97316;
  border-radius: 50%;
  animation: publications-spin 0.7s linear infinite;
  vertical-align: middle;
}

.loading-indicator p {
  color: #6b7280;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 0;
}

/* Action buttons in table */
.publication-action-buttons {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  min-width: 180px;
}

.publication-action-buttons .button {
  width: 100%;
  justify-content: center;
  white-space: nowrap;
  box-sizing: border-box;
  font-size: 1.2rem;
  padding: 0.6rem 1rem;
}

/* Modal détail publication */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Carte démo candidature */
.demo-banner-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  background: #fff7ed;
  border: 1.5px solid #fed7aa;
  border-radius: 8px;
  padding: 1.4rem 2rem;
  margin-bottom: 2.4rem;
}

.demo-banner-card__body {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
  flex: 1 1;
  min-width: 0;
}

.demo-banner-card__badge {
  flex-shrink: 0;
  background: #f97316;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  letter-spacing: 0.03em;
  margin-top: 0.2rem;
}

.demo-banner-card__info {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.demo-banner-card__title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.demo-banner-card__desc {
  font-size: 1.25rem;
  color: #6b7280;
}

.demo-banner-card__error {
  font-size: 1.2rem;
  color: #dc2626;
  margin-top: 0.2rem;
}

.publication-detail-modal {
  background: #fff;
  border-radius: 8px;
  width: 90vw;
  max-width: 900px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.publication-detail-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2rem 1.2rem;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.publication-detail-modal-header h2 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.publication-detail-modal-body {
  overflow-y: auto;
  padding: 1.6rem 2rem;
  flex: 1 1;
}

/* Banniere d'incitation (visiteur non connecte) sous la barre de recherche. */
.publications-auth-banner {
  margin-bottom: 2.4rem;
}
.publications-banner-link {
  color: #f97316;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.publications-banner-link:hover {
  color: #ea580c;
}
/* Meme mise en avant que le lien, mais sans redirection (visiteur connecte). */
.publications-banner-strong {
  font-weight: 600;
}

/* Colonne AAPC : les deux supports de publication empiles, un par ligne.
   L'empilement ne repose PAS sur le flex seul : \`.tableau-container td > div\` est
   plus specifique que cette classe, une regle globale future qui y poserait un
   \`display\` remettrait les deux liens cote a cote. Les liens sont donc eux-memes
   en \`display: block\`, ce qui empile independamment du conteneur.
   line-height serre : la ligne du tableau est bloquee a \`height: 5rem !important\`,
   deux liens a la hauteur de ligne par defaut la feraient deborder. */
.publications-aapc-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.publications-aapc-cell a.lien-externe,
.publications-aapc-cell .lien-externe-inactif {
  display: block;
  width: fit-content;
  line-height: 1.5;
}

/* Paragraphe autonome du bandeau d'information (bloc + respiration sous le texte). */
.publications-banner-paragraphe {
  display: block;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/Publications.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6FAA6F;AAC7F;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,SAAO;AACT;;AAEA,8EAA8E;AAC9E;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA,+EAA+E;AAC/E;EACE,gBAAgB;AAClB;;AAEA;;;;;;sEAMsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".publications-container {\n  padding: 0;\n}\n\n.publications-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.publications-header h1 {\n  /* font-size: 2rem; */\n  font-weight: 700;\n  color: #374151;\n}\n\n/* Aligner les marges du TabNav sur la page Commandes */\n.publications-container .tab-nav {\n  margin-bottom: 3rem;\n}\n\n/* Aligner la marge du button-group sur la page Commandes */\n.publications-container .button-group {\n  margin-top: 0;\n  margin-bottom: 3rem;\n}\n\n/* Loading */\n.loading-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  min-height: 300px;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  margin-top: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.loading-indicator .spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: publications-spin 1s linear infinite;\n  margin-bottom: 1.5rem;\n}\n\n@keyframes publications-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Spinner inline du bouton \"Candidature fictive\" pendant la (re)recuperation de l'AC demo. */\n.demo-btn-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(55, 65, 81, 0.3);\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: publications-spin 0.7s linear infinite;\n  vertical-align: middle;\n}\n\n.loading-indicator p {\n  color: #6b7280;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Action buttons in table */\n.publication-action-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n  min-width: 180px;\n}\n\n.publication-action-buttons .button {\n  width: 100%;\n  justify-content: center;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-size: 1.2rem;\n  padding: 0.6rem 1rem;\n}\n\n/* Modal détail publication */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Carte démo candidature */\n.demo-banner-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.6rem;\n  background: #fff7ed;\n  border: 1.5px solid #fed7aa;\n  border-radius: 8px;\n  padding: 1.4rem 2rem;\n  margin-bottom: 2.4rem;\n}\n\n.demo-banner-card__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.2rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.demo-banner-card__badge {\n  flex-shrink: 0;\n  background: #f97316;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  letter-spacing: 0.03em;\n  margin-top: 0.2rem;\n}\n\n.demo-banner-card__info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.demo-banner-card__title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.demo-banner-card__desc {\n  font-size: 1.25rem;\n  color: #6b7280;\n}\n\n.demo-banner-card__error {\n  font-size: 1.2rem;\n  color: #dc2626;\n  margin-top: 0.2rem;\n}\n\n.publication-detail-modal {\n  background: #fff;\n  border-radius: 8px;\n  width: 90vw;\n  max-width: 900px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n}\n\n.publication-detail-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.6rem 2rem 1.2rem;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.publication-detail-modal-header h2 {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.publication-detail-modal-body {\n  overflow-y: auto;\n  padding: 1.6rem 2rem;\n  flex: 1;\n}\n\n/* Banniere d'incitation (visiteur non connecte) sous la barre de recherche. */\n.publications-auth-banner {\n  margin-bottom: 2.4rem;\n}\n.publications-banner-link {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.publications-banner-link:hover {\n  color: #ea580c;\n}\n/* Meme mise en avant que le lien, mais sans redirection (visiteur connecte). */\n.publications-banner-strong {\n  font-weight: 600;\n}\n\n/* Colonne AAPC : les deux supports de publication empiles, un par ligne.\n   L'empilement ne repose PAS sur le flex seul : `.tableau-container td > div` est\n   plus specifique que cette classe, une regle globale future qui y poserait un\n   `display` remettrait les deux liens cote a cote. Les liens sont donc eux-memes\n   en `display: block`, ce qui empile independamment du conteneur.\n   line-height serre : la ligne du tableau est bloquee a `height: 5rem !important`,\n   deux liens a la hauteur de ligne par defaut la feraient deborder. */\n.publications-aapc-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n}\n\n.publications-aapc-cell a.lien-externe,\n.publications-aapc-cell .lien-externe-inactif {\n  display: block;\n  width: fit-content;\n  line-height: 1.5;\n}\n\n/* Paragraphe autonome du bandeau d'information (bloc + respiration sous le texte). */\n.publications-banner-paragraphe {\n  display: block;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
